import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  ListFoodsResponse,
  Food
} from '../types/apiGeneratedTypes';

export interface RecommendationsPageState {
  searchValue: string;
  appliedFilters: string[];
  isAddFoodModalOpened: boolean;
  foodsList: ListFoodsResponse | null;
  limit: number;
  foodsCount: number | null;
  isDeleteFoodModalOpened: boolean;
  foodToDelete: Food | null;
  foodToEdit: Food | null;
  foodToView: Food | null;
  changeDeleteFoodModalVisibility: boolean;
  changeCreateFoodModalVisibility: boolean;
  memberFoods: ListFoodsResponse | null;
}

export const initialState: RecommendationsPageState = {
  searchValue: '',
  appliedFilters: [],
  isAddFoodModalOpened: false,
  foodsList: null,
  limit: 10,
  foodToEdit: null,
  foodToView: null,
  foodsCount: null,
  isDeleteFoodModalOpened: false,
  foodToDelete: null,
  changeDeleteFoodModalVisibility: false,
  changeCreateFoodModalVisibility: false,
  memberFoods: null
};

const foodsSlice = createSlice({
  name: 'foods',
  initialState,
  reducers: {
    changeCreateFoodModalVisibility(state, action: PayloadAction<boolean>) {
      state.changeCreateFoodModalVisibility = action.payload;
    },
    changeDeleteFoodModalVisibility(state, action: PayloadAction<boolean>) {
      state.isDeleteFoodModalOpened = action.payload;
    },
    setFoodToEdit(state, action: PayloadAction<Food | null>) {
      state.foodToEdit = action.payload;
    },
    setFoodToDelete(state, action: PayloadAction<Food | null>) {
      state.foodToDelete = action.payload;
    },
    setFoodToView(state, action: PayloadAction<Food | null>) {
      state.foodToView = action.payload;
    },
    setFoodsPageSearchValue(state, action: PayloadAction<string>) {
      state.searchValue = action.payload;
    },
    clearFoodsPageSearchValue(state) {
      state.searchValue = '';
    },
    addFilter(state, action: PayloadAction<string>) {
      state.appliedFilters = [...state.appliedFilters, action.payload];
    },
    deleteFilter(state, action: PayloadAction<string>) {
      state.appliedFilters = state.appliedFilters.filter(
        (el) => el !== action.payload
      );
    },
    clearAllFilters(state) {
      state.appliedFilters = [];
    },
    changeModalVisibility(state, action: PayloadAction<boolean>) {
      state.isAddFoodModalOpened = action.payload;
    },
    setFoodsList(state, action: PayloadAction<ListFoodsResponse>) {
      state.foodsList = action.payload;
    },
    setMemberFoods(state, action: PayloadAction<ListFoodsResponse>) {
      state.memberFoods = action.payload;
    },
    setFoodsCount(state, action: PayloadAction<number>) {
      state.foodsCount = action.payload;
    },
    appendFoodsList(state, action: PayloadAction<ListFoodsResponse>) {
      if (state.foodsList) {
        state.foodsList = {
          ...state.foodsList,
          foods: [...state.foodsList.foods, ...action.payload.foods]
        };
      }
    }
  }
});

export const {
  setFoodsPageSearchValue,
  clearFoodsPageSearchValue,
  addFilter,
  deleteFilter,
  clearAllFilters,
  changeModalVisibility,
  setFoodsList,
  appendFoodsList,
  setFoodToEdit,
  setFoodToDelete,
  setFoodToView,
  setFoodsCount,
  changeDeleteFoodModalVisibility,
  changeCreateFoodModalVisibility,
  setMemberFoods
} = foodsSlice.actions;
export default foodsSlice.reducer;
